module.exports = __webpack_public_path__ + "static/media/bg-1.6b8fc5d8.png";